import React from 'react';
import { FadeIn } from './FadeIn';
import { Brain, ZapOff, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-159">
      <FadeIn data-id="element-160">
        <div className="bg-slate-800/50 border border-slate-700/50 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8" data-id="element-162">
            El problema real no eres tú
          </h2>

          <div className="space-y-8" data-id="element-163">
            <div className="flex items-start gap-4" data-id="element-164">
              <div className="bg-amber-500/10 p-3 rounded-xl mt-1" data-id="element-165">
                <Brain className="w-6 h-6 text-amber-500" data-id="element-166" />
              </div>
              <div data-id="element-167">
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-168">
                  La mayoría de los consejos de productividad están diseñados
                  para cerebros que producen dopamina de forma constante. Para
                  ellos, "solo hazlo" es una instrucción válida.{' '}
                  <strong className="text-white" data-id="element-169">
                    Para ti, es un insulto.
                  </strong>
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-170">
              <div className="bg-amber-500/10 p-3 rounded-xl mt-1" data-id="element-171">
                <ZapOff className="w-6 h-6 text-amber-500" data-id="element-172" />
              </div>
              <div data-id="element-173">
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-174">
                  En el cerebro con TDAH, el costo energético de simplemente
                  comenzar una tarea aburrida o compleja es{' '}
                  <strong className="text-amber-400" data-id="element-175">
                    diez veces más alto
                  </strong>{' '}
                  que para una persona promedio. No es que no quieras; es que tu
                  cerebro detecta la tarea como una amenaza a su reserva de
                  combustible.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-176">
              <div className="bg-amber-500/10 p-3 rounded-xl mt-1" data-id="element-177">
                <AlertTriangle className="w-6 h-6 text-amber-500" data-id="element-178" />
              </div>
              <div data-id="element-179">
                <p className="text-lg text-slate-300 leading-relaxed" data-id="element-180">
                  El resultado es el colapso: te distraes con el teléfono,
                  limpias la casa para no trabajar o te quedas mirando el vacío
                  mientras la culpa te carcome por dentro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}